module.exports = __webpack_public_path__ + "img/aParty_1208_F.9a062508.jpg";